import React from 'react'
import set from 'lodash.set'

import { updateEventFeed } from '../../../services/data-explorer'
import { useRequestConfig } from '_hooks'
import { useEventFeedsContext } from '../../pages/event-feeds/context/index.jsx'
import IntervalSelect, { TIME_INTERVAL_VALUES } from '../interval-select'

const IntervalSelectStored = ({ visualizationsPath, type = 'events', vertical }) => {
  const { id, data, dispatch, ACTIONS } = useEventFeedsContext()
  const { interval } = useRequestConfig(visualizationsPath)

  const persistInterval = (intervalValue) => {
    const newValue = { ...data?.visualizations }

    set(newValue, visualizationsPath + '.interval', intervalValue)

    const newData = { ...data, visualizations: newValue }
    updateEventFeed(id, newData)
    dispatch({ type: ACTIONS.SET_DATA, payload: newData })
  }

  return (
    <If condition={data?._id || id === 'discovery'}>
      <IntervalSelect
        vertical={vertical}
        interval={interval}
        onIntervalChange={(intervalValue) => persistInterval(intervalValue)}
        intervalOptions={
          type === 'users'
            ? [
                { label: 'Daily', value: TIME_INTERVAL_VALUES.DAILY },
                { label: 'Monthly', value: TIME_INTERVAL_VALUES.MONTHLY },
              ]
            : undefined
        }
      />
    </If>
  )
}

export default IntervalSelectStored
